import React, { forwardRef, useContext, useImperativeHandle } from "react";
import { FlexContainer, LottieAnimation, Text, Toast } from "src/components";
import { Content, TextLabel, StyledInput } from "./styled";
import RestoreBackupAnimation from "./assets/restore.json";

import { usePasswordValidator } from "src/scenes/Chat/hooks";
import { BackupKeyContext } from "../../BackupKeyContext";
import { BACKUP_KEY_FORMS } from "src/scenes/Chat/hooks/chat/useBackupForm";

const Restore = forwardRef((props, ref) => {
    const { password, setPassword } = usePasswordValidator();
    const { updateBackupKeyFormToShow } = useContext(BackupKeyContext);

    const handleSubmit = () => {
        if (password.trim() === "") {
            return Toast.error("Password cannot be empty.");
        }

        props.handleRestoration(password);
    };

    const handleForgotPassword = () => {
        updateBackupKeyFormToShow(BACKUP_KEY_FORMS.RESET);
    };

    useImperativeHandle(ref, () => ({ submit: handleSubmit }));

    return (
        <Content>
            <FlexContainer justifyContent="center" alignItems="center">
                <LottieAnimation animationJsonData={RestoreBackupAnimation} />
                <Text size="1.25rem" weight="700">Restore Your Chat History</Text>
                <Text size="1rem" margin="0" style={{ maxWidth: "34.5rem" }}>
                        Your existing Chat backup could not be unlocked automatically.<br />
                        Enter the Chat backup password you chose when the backup was created. It may be different
                        from your current login password.
                        If you’ve forgotten your password, you can generate a new one to secure future chats.
                </Text>
                <Text size="1rem" weight="700" margin="16px 0 50px 0">
                        Note: Previous chat history will be lost if creating a new password.
                </Text>
                <TextLabel>Enter Chat Backup Password</TextLabel>
                <StyledInput placeholder="Enter your password"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <Text size="1rem" weight="700" margin="39px 0 0 0"
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={handleForgotPassword}
                >
                        Forgot Password
                </Text>
            </FlexContainer>
        </Content>
    );
});

export default Restore;
